// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Fqdn, Text } from '@gandi/ui';

import {
  AvailabilityIcon,
  type AvailabilityIconName,
} from './AvailabilityIcon';

import PlaceholderRow from './Placeholder/PlaceholderRow';

import styles from './Unavailable.scss';

type Props = {
  availabilityIconName: AvailabilityIconName,
  availabilityText: string,
  children: React.Node,
  /// TODO: re-input the error
  // error?: boolean,
  fqdn: string,
};

function Container({
  children,
  renderButton,
  availabilityIconName,
}: {
  children: React.Node,
  renderButton?: React.Node,
  availabilityIconName: AvailabilityIconName,
}) {
  return (
    <Base
      flex
      flexWrap
      flexJustifyBetween
      padding="small"
      rowGap="small"
      className={styles.unavailableBox}
    >
      <Base columnGap="small" flexAlignItemsCenter className={styles.container}>
        <AvailabilityIcon
          iconName={availabilityIconName}
          className={styles.svgBox}
        />
        {children}
      </Base>
      {renderButton}
    </Base>
  );
}

export default function Unavailable({
  availabilityIconName,
  availabilityText,
  fqdn,
  children,
}: Props): React.MixedElement {
  if (!availabilityText) {
    return <PlaceholderRow isProvided />;
  }

  return (
    <Container
      availabilityIconName={availabilityIconName}
      renderButton={
        <Base
          flex
          columnGap="small"
          flexAlignItemsCenter
          flexJustifyBetween
          className={styles.buttonBlock}
        >
          {children}
        </Base>
      }
    >
      <Text className={styles.info}>{availabilityText}</Text>
      <Base
        weight="semibold"
        flex
        columnGap="xsmall"
        flexAlignItemsBaseline
        className={styles.fqdnBlock}
      >
        <Fqdn maxLength={42} color="weak">
          {fqdn}
        </Fqdn>
      </Base>
    </Container>
  );
}

Unavailable.Error = function UnavailableError({
  fqdn,
}: {
  fqdn: string,
}): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <Container availabilityIconName="fail">
      <Text className={styles.info}>
        {__('Something seems broken right now.')}
      </Text>
      <Base
        weight="semibold"
        flex
        columnGap="xsmall"
        flexAlignItemsBaseline
        className={styles.fqdnBlock}
      >
        {/* No Fqdn component in the ErrorBoundary:
            don't try to decode punycode again if it was the reason we are here.
          */}
        {fqdn}
      </Base>
    </Container>
  );
};
